import React from 'react';
import { CheckCircle, Info, WarningCircle, XCircle } from '@phosphor-icons/react';

export function CandidateValidationNotice({ tone = 'warning', title, children }) {
    const Icon = tone === 'success' ? CheckCircle : tone === 'info' ? Info : tone === 'danger' ? XCircle : WarningCircle;
    const alertRole = tone === 'warning' || tone === 'danger';

    return (
        <div className={`candidate-validation-notice is-${tone}`} role={alertRole ? 'alert' : 'status'}>
            <Icon size={24} weight="fill" aria-hidden="true" />
            <div>
                {title && <strong>{title}</strong>}
                {children && <span>{children}</span>}
            </div>
        </div>
    );
}
